import { defineStore } from 'pinia';
import { initUserInfo } from './utils';
export default defineStore('login', {
    state: () => {
        return {
            token: '',
            userInfo: {},
        };
    },
    getters: {
        getPermCodeList() {
            if (this.userInfo == null)
                return new Set();
            return new Set(this.userInfo.permCodeList);
        },
    },
    actions: {
        setUserInfo(info) {
            this.userInfo = initUserInfo(info);
        },
        setHeadImage(headImage) {
            if (this.userInfo == null)
                return;
            this.userInfo.headImageUrl = headImage;
        },
    },
    persist: {
        // 开启持久存储
        enabled: true,
        // 指定哪些state的key需要进行持久存储
        // storage默认是 sessionStorage存储
        // paths需要持久存储的key
        strategies: [{ key: 'userInfo', paths: ['userInfo'] }],
    },
});
